import { cn } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'

import { ExclamationMark } from '@/assets/icons/ExclamationMark'
import { useAppSelector } from '@/hooks/store'
import { MapPageError } from '@/store/cartSlice/selectors/mapPageErrorsSelector'
import { ticketSlice } from '@/store/ticketSlice'
import {
  getMapPageErrorAnchor,
  scrollToMapPageErrorAnchor,
} from '@/utils/mapPageErrorPresentation'

interface Props {
  errors: MapPageError[]
}

export function SetupCartActionsSpotErrors({ errors }: Props) {
  const { t } = useTranslation()
  const submitted = useAppSelector(ticketSlice.selectors.submitted)
  const validationScope = useAppSelector(ticketSlice.selectors.validationScope)

  if (!submitted || validationScope !== 'spot' || errors.length === 0) {
    return null
  }

  const handleClick = () => {
    scrollToMapPageErrorAnchor(getMapPageErrorAnchor(errors[0]))
  }

  return (
    <button
      className={cn(
        'sticky bottom-0 z-20 -mx-4 mt-4 flex w-[calc(100%+0rem)] items-center gap-2',
        'mx-0 border border-red-600 bg-red-50 px-4 py-2 text-left',
        'cursor-pointer transition-colors hover:bg-red-100'
      )}
      onClick={handleClick}
      type="button"
    >
      <ExclamationMark className="size-5 shrink-0 text-red-600" />
      <p className="text-sm text-red-600">{t('ticketErrors.banner')}</p>
    </button>
  )
}
